import { useRowSelect } from '@table-library/react-table-library/select';
import { Action, State } from '@table-library/react-table-library/types/common';
import { Button, TableItem } from 'components/atoms';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useTranslation } from 'react-i18next';
import { PiUserPlus } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetClientAccounts } from 'services/client-account';
import { IClientAccountInfiniteResponse } from 'services/client-account/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getNodes } from 'utils/table/nodes.utils';

const ClientAccounts = () => {
  const accounts = useGetClientAccounts();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const tableData = getNodes<IClientAccountInfiniteResponse>(
    accounts.data?.pages.flat()
  );

  const onSelectChange = (action: Action, state: State) => {
    navigate(`${state.id ?? state.ids[state.ids.length - 1]}/users`);
  };

  const select = useRowSelect(tableData, {
    onChange: onSelectChange,
  });
  return (
    <TopbarPage
      topbar={
        <TopBar
          title={t(`client-account.title.list`)}
          hideBackButton
          topbarContent={
            <Button
              variant={BUTTON_VARIANT.submit}
              onClick={() => navigate('create/users', { replace: false })}>
              <Button.Text text={t('button.add')} />
              <Button.Icon icon={<PiUserPlus />} />
            </Button>
          }
        />
      }>
      <Table
        id={'ClientAccounts'}
        select={select}
        data={tableData}
        loading={accounts.isLoading || accounts.isFetchingNextPage}
        onFullyScroll={accounts.fetchNextPage}
        displayMode
        columns={[
          {
            label: t('input.label.name'),
            renderCell: ({ labelName }) => (
              <TableItem>
                <TableItem.Text text={labelName} />
              </TableItem>
            ),
            resize: true,
          },
          //   {
          //     label: t('input.label.firstName'),
          //     renderCell: ({ firstName }) => (
          //       <TableItem>
          //         <TableItem.Text text={firstName} />
          //       </TableItem>
          //     ),
          //     resize: true,

          //   },
        ]}
      />
    </TopbarPage>
  );
};

export default ClientAccounts;
